import React from 'react';
import { Progress } from 'antd';


const ProgressGraph = (data) => {
  let percentUpdate = data.percent;
  let status = "normal";
  let color = data.sex === "Male" ? "#4d9af8" : "#ff6666";
  let remainingColor = data.sex === "Male" ? "#a6cdff" : "#ffcccc";
  let sizeTotal = data.size;

  if (data.sex === "Total") {
    color = "#68e179";
    remainingColor = "#c2ffbe";
    let total = 0;
    let remaining = 0;
    for (const age in data.percent) {
      const { totalM = 0, totalF = 0, remainingM = 0, remainingF = 0 } = data.percent[age];
      total += totalM + totalF;
      remaining += remainingM + remainingF;
    }
    percentUpdate = [remaining, total];
  }

  if (data.percent === -1) {
    status = "exception";
    return (
      <div className="flex justify-center items-center flex-col text-center h-full">
        <Progress
          type="dashboard"
          percent={0}
          status={status}
          trailColor={"rgb(243,109,109)"}
        />
        <label className="pt-1.5">{data.legend}</label>
      </div>
    )
  } else if (data.percent === 100) {
    status = "success";
  }
  return (
    <div className="flex justify-center items-center flex-col text-center h-full">
      <div className="-z-50">
        <Progress
          type="dashboard"
          format={(percent) => (
            <div className="text-center flex flex-col justify-center">
              <p className="text-xs text-gray-500">{percent + "%"}</p>
              <div className="flex flex-row justify-center items-end ">
                <p className="text-3xl">{percentUpdate[1] - percentUpdate[0]}/</p>
                <p className="text-sm">{percentUpdate[1]}</p>
              </div>
              {percentUpdate[0] === 0 ? (
                <div className="flex flex-row justify-center">
                  <p className="text-sm text-primary text-center">Concluído</p>
                </div>
              ) : (
                <div className="flex flex-row justify-center">
                  <p className="text-xs text-red-600 text-center">Faltam: {percentUpdate[0]} </p>
                </div>
              )}
            </div>
          )}
          percent={((1 - (percentUpdate[0] / percentUpdate[1])) * 100).toFixed(1)}
          strokeColor={color}
          status={status}
          trailColor={remainingColor}
          size={sizeTotal}
          strokeLinecap='square'
        />
      </div>
      <label>{data.legend}</label>
    </div>
  );
}
export default ProgressGraph;
